<template>
  <svg class="fill-current" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 27.1667L5.33331 16.5L16 5.83337L17.9 7.70004L10.4333 15.1667H26.6666V17.8334H10.4333L17.9 25.3L16 27.1667Z"
      fill="white"
    />
  </svg>
</template>
